import { useAuthz } from "@/lib/auth/authz";
import { LanguageProvider, persistLanguage } from "@/lib/i18n/language";
import { NotificationsProvider } from "@/lib/notifications/notifications";
import { DensityProvider } from "@/lib/prefs/density";
import { BackOfficeLayout } from "./BackOfficeLayout";
import { ClubLayout } from "./ClubLayout";

/**
 * Role-based shell selector (architecture §4.3). Mounts BackOfficeLayout for TC staff and
 * ClubLayout for club users — a Club user can never render a back-office surface (the API
 * enforces the same boundary). Waits for /api/me so the shell renders with a known user type,
 * then provides the language context seeded from the user's stored preference.
 */
export function RoleLayout() {
  const { me, isLoading, isBackOffice } = useAuthz();

  if (isLoading || !me) {
    // Brief hold while /api/me resolves — avoids flashing the wrong shell.
    return <div className="muted" style={{ padding: "12vh 24px", textAlign: "center" }} />;
  }

  return (
    <LanguageProvider initial={me.language} persist={persistLanguage}>
      <DensityProvider initial={me.density}>
        <NotificationsProvider>
          {isBackOffice ? <BackOfficeLayout /> : <ClubLayout />}
        </NotificationsProvider>
      </DensityProvider>
    </LanguageProvider>
  );
}
